angular.module('mavibayrak')
  .controller('BeachCtrl', function ($scope, $stateParams, $state, $ionicPopup, $ionicHistory, Beaches, Cities, Towns, Audits, Utils) {
    var audit, action = 'update';

    // Edit
    if ($stateParams.auditId) {
      audit = Audits.getStored($stateParams.auditId);
      if (!audit) {
        $ionicHistory.nextViewOptions({historyRoot: true});
        $ionicPopup.alert({ template: 'Kayıt bulunamadı. id: ' + $stateParams.auditId})
          .then(function () { $state.go('tab.beaches'); });
        return;
      }
    // New
    } else {
      // Tek draft kayıt saklanır, onu alalım
      audit = Audits.getDraft('beach');
      // Kayıtlı draft varsa ve farklı bir plaja aitse silelim
      if (audit && audit.beach.id != $stateParams.beachId) {
        Audits.deleteUnsavedData('beach');
        audit = null;
      }
      // Kayıtlı draft yoksa ya da önceki adımda sildiysek default data'ları oluşturalım
      if (!audit) {
        audit = Audits.newRecord();
        audit.beach = Beaches.get($stateParams.beachId);
        action = 'insert';
      }
    }

    // Convert created_at to date object.
    // toISOString timezone verisi içermez, ekleyelim
    var date = new Date(audit.audit.created_at);
    audit.audit.created_at = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));


    $scope.audit = audit.audit;
    $scope.beach = audit.beach;
    $scope.city = Cities.get($scope.beach.city_id);
    $scope.town = Towns.get($scope.beach.town_id);
    $scope.classes = Beaches.classes;
    $scope.methods = Audits.methods;
    $scope.types = Audits.types;

    $scope.gotoQuestions = function () {
      if (action == 'insert') {
        Audits.insert(audit);
      } else {
        Audits.update(audit.id, {
          audit: $scope.audit,
          beach: $scope.beach
        });
      }
      $state.go('tab.questions_beach', {auditId: audit.id, page: 1});
    };

    $scope.cancelAudit = function () {
      Utils.cancelAudit(audit);
    };
  });